import { Link } from "react-router-dom";
import HeroBreadcrumb from "@/components/layout/HeroBreadcrumb";
import { Download, ExternalLink, ArrowRight, Mail, Phone } from "lucide-react";

/* ── Accordi Interconfederali ─────────────────────────────────────────── */
const INTERCONFEDERALI_DOCS = [
  { label: "Accordo sulla misurazione della rappresentanza datoriale – 10 luglio 2026", url: "https://www.confcommerciomilano.it/export/sites/unione/doc/contratti_lavoro/lavoro_news/2026/lavoronews_n_34/ALL.-COM.-Rappresentanza-datoriale_10luglio2026.pdf" },
];

/* ── Contrattazione territoriale ─────────────────────────────────────── */
const TERRITORIALE_DOCS = [
  { label: "CIR – Contratto Integrativo Regionale Terziario", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/CIR-TERZIARIO-CON-ACCORDI-REGIONALI-4.pdf" },
  { label: "Accordo detassazione Terziario", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/Comunicazione-per-lapplicazione-dellAccordo-Territoriale-sulla-detassazione-3.pdf" },
  { label: "Accordo Detassazione PPEE", url: null },
  { label: "Accordo stagionalità", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/Comunicazione-per-lapplicazione-dellAccordo-Territoriale-sulla-stagionalita-2.pdf" },
];

/* ── CCNL ──────────────────────────────────────────────────────────────── */
const CCNL_LIST = [
  {
    id: "terziario",
    titolo: "CCNL Terziario, Distribuzione e Servizi",
    desc: "Il CCNL Terziario, Distribuzione e Servizi, per dipendenti e dirigenti, sottoscritto da Confcommercio, si applica ad oltre 2 milioni ed 800 mila addetti. Il contratto disciplina i rapporti di lavoro a tempo indeterminato e, per quanto compatibile con le disposizioni di legge, i rapporti di lavoro a tempo determinato e di somministrazione a tempo determinato, tra tutte le aziende del terziario di mercato (distribuzione e servizi). È applicabile a qualsiasi modalità, comprese vendita per corrispondenza e commercio elettronico. Il 22 marzo 2024 il contratto è stato rinnovato, con validità dal primo aprile 2024 al 31 marzo 2027.",
    image: "/local-assets/terziario-firma-documento.webp",
    docs: [
      { label: "Stesura CCNL Terziario, Distribuzione e Servizi", url: "/local-assets/Stesura-CCNL-Terziario-Distribuzione-e-Servizi.pdf" },
      { label: "Ipotesi di accordo del CCNL Terziario, Distribuzione e Servizi del 22 marzo 2024", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/Ipotesi_di_accordo_22.03.2024.pdf" },
      { label: "Protocollo Straordinario di Settore – 12 dicembre 2022", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/Protocollo-straordinario-CCNL-Terziario.pdf" },
      { label: "CCNL Terziario, Distribuzione e Servizi del 30 luglio 2019", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/Testo-CCNL.pdf" },
    ],
    extUrl: null,
  },
  {
    id: "dirigenti",
    titolo: "CCNL Dirigenti terziario, distribuzione e servizi",
    desc: "Confcommercio e Manageritalia hanno firmato il 5 novembre 2025 il rinnovo del contratto nazionale di lavoro dei dirigenti del terziario, che interessa oltre 32mila dirigenti e oltre 10mila aziende di settori portanti dell'economia nazionale (commercio, distribuzione moderna, servizi alle imprese, digitale, moda e lusso, automotive, fiere, turismo, non profit). Tra le novità: welfare, invecchiamento attivo, genitorialità e parità di genere.",
    image: "/local-assets/dirigenti-terziario-colloquio-ufficio.webp",
    docs: [
      { label: "Rinnovo Accordo 12-aprile-2023", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/11/CCNL_Dirigenti_12-aprile-2023.pdf" },
      { label: "Rinnovo Accordo 5 novembre 2025", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/11/CCNL_Dirigenti_5_novembre-2025-1.pdf" },
    ],
    extUrl: null,
  },
  {
    id: "pubblici-esercizi",
    titolo: "CCNL Pubblici esercizi e ristorazione collettiva e commerciale e turismo",
    desc: "Il Contratto collettivo nazionale per i dipendenti dei settori dei Pubblici Esercizi, della Ristorazione Collettiva e Commerciale e del Turismo è firmato per la parte datoriale dai rappresentanti della FIPE, di Angem, di Legacoop Produzione e Servizi, che rappresentano la quasi totalità delle Imprese del settore. Il Contratto, firmato l'8 febbraio 2018 e scaduto il 31 dicembre 2021, è stato rinnovato il 5 giugno 2024 con scadenza il 31 dicembre del 2027. Il CCNL ha un campo di applicazione che interessa oltre un milione di addetti di un settore dove operano più di 300mila imprese, con un fatturato di oltre 80 miliardi di euro. Tra i lavoratori che fanno riferimento al CCNL troviamo bar, ristoranti, trattorie, pizzerie, pub, mense scolastiche ospedaliere e aziendali, grandi aziende della ristorazione commerciale multi localizzata, imprese della ristorazione collettiva, cooperative della ristorazione, stabilimenti balneari, discoteche, sale giochi.",
    image: "/local-assets/pubblici-esercizi-ristorazione-lounge.webp",
    docs: [],
    extUrl: "https://www.confcommercio.it/-/ccnl-per-i-dipendenti-dei-settori-dei-pubblici-esercizi",
  },
  {
    id: "cococo",
    titolo: "Accordo collettivo per la disciplina delle co.co.co.",
    desc: null,
    image: "/local-assets/cococo-call-center.webp",
    docs: [
      { label: "Ipotesi di accordo collettivo per la disciplina delle collaborazioni coordinate e continuative per call center, servizi non di telefonia e servizi realizzati attraverso operatori telefonici", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/accordo-cococo.pdf" },
    ],
    extUrl: null,
  },
  {
    id: "aec",
    titolo: "AEC Agenti e Rappresentanti del Commercio",
    desc: "Il contratto di agenzia e rappresentanza commerciale tra le case mandanti (\"ditte\") e gli agenti e rappresentanti di commercio è disciplinato dalle norme contenute nell'Accordo Economico Collettivo – AEC sottoscritto da Confcommercio con le associazioni più rappresentative degli agenti. L'Accordo Economico è in fase di rinnovo.",
    image: "/local-assets/aec-agenti-handshake.webp",
    docs: [
      { label: "AEC Accordo 29 marzo 2017", url: "https://www.confcommerciomilano.it/export/sites/unione/doc/contratti_lavoro/lavoro_news/2017/lavoronews_n_26/AEC-allegato-con-firme.pdf" },
      { label: "AEC Accordo 4 giugno 2025", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/06/Rinnovo_AEC_4_giugno_2025_firmato-1.pdf" },
    ],
    extUrl: null,
  },
  {
    id: "panificazione",
    titolo: "CCNL Alimentare panificazione Assipan",
    desc: "Il Contratto Collettivo Nazionale del Lavoro per i lavoratori dipendenti delle aziende di panificazione stabilisce le condizioni normative e retributive minime garantendo equità e tutela ai lavoratori. Il 18 luglio 2024 Assipan, l'Associazione italiana panificatori e affini, con l'assistenza di Confcommercio, ha sottoscritto l'accordo di rinnovo del CCNL con Flai Cgil, Fai Cisl, Uila Uil. Il nuovo Contratto sarà valido fino al 31 dicembre 2026.",
    image: "/local-assets/assipan-panificazione-bakery.webp",
    docs: [],
    extUrl: "https://www.confcommercio.it/-/ccnl-panificatori",
  },
  {
    id: "autotrasporto",
    titolo: "CCNL Autotrasporto merci e logistica",
    desc: "Organizzazioni datoriali e sindacati hanno sottoscritto il 18 maggio 2024 l'accordo di rinnovo del Contratto collettivo nazionale di lavoro logistica, trasporto e spedizione, scaduto il 31 dicembre 2019.",
    image: "/local-assets/autotrasporto-logistica-trucks.webp",
    docs: [],
    extUrl: "https://www.confcommercio.it/-/rinnovo-contratto-trasporto-spedizione-logistica",
  },
  {
    id: "sport",
    titolo: "CCNL Dipendenti da impianti e attività sportive profit e no profit",
    desc: "In data 12 gennaio 2024, la Confederazione dello Sport, con l'assistenza di Confcommercio-Imprese per l'Italia, insieme a Slc Cgil, Fisascat Cisl e Uilcom Uil, hanno raggiunto l'accordo per il rinnovo del CCNL per i lavoratori dello Sport. Il CCNL ha vigenza dal 1° gennaio 2024 – 31 dicembre 2026. Nello specifico, si tratta del rinnovo del CCNL in precedenza denominato \"Impianti sportivi e palestre\", che cambia denominazione con il mantenimento del medesimo codice INPS-CNEL H077. Il nuovo CCNL modifica e innova numerosi istituti, sia di carattere economico che normativo. Inoltre, è stata effettuata un'armonizzazione con la nuova riforma dello sport, con particolare riferimento alle disposizioni introdotte dal d.lgs. n. 36/2021.",
    image: "/local-assets/sport-palestra-gym-fitness.webp",
    docs: [],
    extUrl: "https://www.confcommercio.it/-/ccnl-addetti-impianti-e-attivita-sportive",
  },
  {
    id: "vigilanza",
    titolo: "CCNL Dipendenti vigilanza privata e servizi fiduciari",
    desc: "Il 4 aprile 2024 è stato raggiunto un importante accordo per il rinnovo del Contratto Collettivo Nazionale per i lavoratori del settore vigilanza privata e servizi fiduciari. L'intesa, sottoscritta da Univ, Anivp, (aderenti a ConFederSicurezza e Servizi – Confcommercio), Assiv, Legacoop Produzione e Servizi, AGCI Servizi e Confcooperative Lavoro e Servizi con le sigle sindacali Filcams-Cgil, Fisascat-Cisl e Uiltucs-Uil, modifica e integra l'accordo del 30 maggio 2023. Il nuovo CCNL decorre dal 1° giugno 2023 e scadrà il 31 dicembre 2026. La nuova intesa ha apportato delle modifiche alle tabelle retributive concordate con l'accordo del 30 maggio 2023.",
    image: "/local-assets/vigilanza-privata-security-guard.webp",
    docs: [],
    extUrl: "https://www.confcommercio.it/-/contratto-univ-sicurezza",
  },
  {
    id: "alberghiero",
    titolo: "CCNL dirigenti di aziende alberghiere",
    desc: null,
    image: "/local-assets/alberghiero-dirigenti-hotel-lobby.webp",
    docs: [
      { label: "CCNL per i dirigenti di aziende alberghiere – 28 novembre 2023", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/1-accordo-dirigenti-Federalberghi-28-nov-2023.pdf" },
      { label: "Accordo proroga 30/7/2021", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/2-Accordo-dirigenti-Federalberghi-30-luglio-2021.pdf" },
      { label: "Accordo proroga 18/9/2019", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/3-accordo-proroga-18092019-Federalberghi.pdf" },
      { label: "CCNL per i dirigenti di aziende alberghiere – 21 dicembre 2016", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/4-CCNL-dirigenti-alberghi-21-12-16.pdf" },
    ],
    extUrl: null,
  },
  {
    id: "viaggi",
    titolo: "CCNL Imprese di viaggi e turismo",
    desc: null,
    image: "/local-assets/viaggi-turismo-terrazza-mare.webp",
    docs: [
      { label: "Ipotesi di accordo di rinnovo del CCNL per i dipendenti delle imprese di viaggi e turismo – 26 luglio 2024", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/CCNL-per-dipendenti-delle-imprese-di-viaggio-e-turismo.pdf" },
      { label: "CCNL per i dipendenti da aziende del settore turismo – 24 luglio 2019", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/FIAVET-ccnl-firmato-24-luglio-2019.pdf" },
    ],
    extUrl: null,
  },
  {
    id: "multiservizi",
    titolo: "CCNL Multiservizi",
    desc: null,
    image: "/local-assets/multiservizi-pulizia-cleaning.webp",
    docs: [
      { label: "CCNL imprese di pulizia, di disinfestazione, servizi integrali/multiservizi (rinnovo siglato il 26 novembre 2021)", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/1-CCNL_FNIP-Confcommercio-26-Nov-2021_FIRMATO.pdf" },
      { label: "CCNL imprese di pulizia, di disinfestazione, servizi integrali/multiservizi (rinnovo siglato il 21 luglio 2011)", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/2-FNIP-firmato-3-agosto-2011.pdf" },
      { label: "CCNL imprese di pulizia, di disinfestazione, servizi integrali/multiservizi (siglato il 19 dicembre 2007)", url: "https://www.confcommercioroma.it/wp-content/uploads/2025/03/3-CCNL-imprese-pulizia-TU-2007.pdf" },
    ],
    extUrl: null,
  },
  {
    id: "socio-sanitario",
    titolo: "CCNL per il personale dipendente del settore socio sanitario",
    desc: "Il CCNL è in fase di Rinnovo.",
    image: "/local-assets/socio-sanitario-infermiera-visita.webp",
    docs: [],
    extUrl: "https://www.confcommercio.it/-/contratto-socio-sanitario",
  },
];

function DocItem({ doc }) {
  if (!doc.url) {
    return (
      <div className="flex items-center gap-4 p-5 rounded-xl border border-[var(--confcom-border)] opacity-60">
        <div className="flex-1">
          <p className="text-sm font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed']">{doc.label}</p>
          <p className="text-xs text-[var(--confcom-text-muted)] mt-0.5">In aggiornamento</p>
        </div>
        <Download size={18} className="text-[var(--confcom-text-muted)] shrink-0" aria-hidden="true" />
      </div>
    );
  }
  return (
    <a
      href={doc.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex items-center gap-4 p-5 rounded-xl border border-[var(--confcom-border)] bg-white hover:border-[var(--confcom-blue)]/30 hover:shadow-md transition-all"
    >
      <p className="flex-1 text-sm font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] group-hover:text-[var(--confcom-blue)] transition-colors">{doc.label}</p>
      <Download size={18} className="text-[var(--confcom-text-muted)] shrink-0 group-hover:text-[var(--confcom-blue)] transition-colors" aria-hidden="true" />
    </a>
  );
}

export default function ContrattazioneCollettivaPage() {
  return (
    <main id="main-content" data-testid="contrattazione-page">

      {/* Hero */}
      <section className="relative h-[280px] md:h-[340px] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1672380135241-c024f7fbfa13?w=1920&q=60&auto=format" alt="Contrattazione collettiva" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.82)" }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-10">
          <HeroBreadcrumb />
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Area Lavoro e Welfare</span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mt-2 font-['Encode_Sans_Semi_Condensed'] tracking-tight">Contrattazione collettiva<br />e Relazioni sindacali</h1>
        </div>
      </section>

      {/* Intro */}
      <section className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-lg text-[var(--confcom-text-secondary)] leading-relaxed mb-4">
              Rappresentiamo le aziende associate nella trattativa e nella sottoscrizione dei principali <strong className="text-[var(--confcom-text-primary)]">Accordi Interconfederali</strong>, <strong className="text-[var(--confcom-text-primary)]">Contratti Collettivi Nazionali di categoria</strong> e dei <strong className="text-[var(--confcom-text-primary)]">Contratti Territoriali Integrativi</strong>.
            </p>
            <p className="text-[var(--confcom-text-secondary)] leading-relaxed">
              Consulta e scarica i principali CCNL sottoscritti da Confcommercio e gli Accordi territoriali di Roma e Lazio. Il nostro Team sindacale è a disposizione per chiarimenti e consulenza personalizzata su ogni aspetto della contrattazione.
            </p>
          </div>
        </div>
      </section>

      {/* Accordi Interconfederali */}
      <section className="py-14 bg-[#EBF5FF]" id="interconfederali">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-10 items-start">
            {/* Testo + docs */}
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Accordi Interconfederali</span>
              <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mt-2 mb-3">Misurazione della Rappresentanza</h2>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-6">
                Le intese sulla misurazione della rappresentanza sindacale sono volte a consolidare, all'interno di un quadro di regole certe e condivise, il ruolo delle parti sociali e della contrattazione collettiva di qualità.
              </p>
              <div className="grid sm:grid-cols-2 gap-4">
                {INTERCONFEDERALI_DOCS.map((doc) => (
                  <DocItem key={doc.label} doc={doc} />
                ))}
              </div>
            </div>
            {/* Immagine */}
            <div className="rounded-2xl overflow-hidden shadow-md">
              <img
                src="https://images.unsplash.com/photo-1562564055-71e051d33c19?w=800&q=80&auto=format"
                alt="Sottoscrizione di un accordo interconfederale"
                className="w-full h-72 lg:h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      <div className="h-10 bg-white" aria-hidden="true" />

      {/* Contrattazione territoriale */}
      <section className="py-14 bg-[#EBF5FF]" id="territoriale">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-10 items-start">
            {/* Testo + docs */}
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Accordi locali</span>
              <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mt-2 mb-3">Contrattazione territoriale Roma e Lazio</h2>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-6">
                Gli accordi integrativi stipulati a livello territoriale per le province di Roma e per la Regione Lazio, comprese le intese speciali legate al Giubileo 2025.
              </p>
              <div className="grid sm:grid-cols-2 gap-4">
                {TERRITORIALE_DOCS.map((doc) => (
                  <DocItem key={doc.label} doc={doc} />
                ))}
              </div>
            </div>
            {/* Immagine */}
            <div className="rounded-2xl overflow-hidden shadow-md">
              <img
                src="https://images.unsplash.com/photo-1555992828-ca4dbe41d294?w=800&q=80&auto=format"
                alt="Roma, sede della contrattazione territoriale"
                className="w-full h-56 lg:h-72 object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CCNL list */}
      <section className="py-14 bg-white" id="ccnl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Contratti nazionali</span>
          <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mt-2 mb-10">CCNL di riferimento</h2>

          <div className="flex flex-col gap-6">
            {CCNL_LIST.map((ccnl) => (
              <div
                key={ccnl.id}
                id={ccnl.id}
                className="bg-white rounded-xl border border-[var(--confcom-border)] overflow-hidden flex flex-col md:flex-row"
                data-testid={`ccnl-${ccnl.id}`}
              >
                {/* Immagine */}
                <div className="w-full h-56 md:h-auto md:w-64 md:aspect-square md:self-stretch shrink-0 overflow-hidden">
                  <img
                    src={ccnl.image}
                    alt={ccnl.titolo}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                {/* Contenuto */}
                <div className="flex-1 p-6 flex flex-col gap-4">
                  <div>
                    <h3 className="text-base font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-2">{ccnl.titolo}</h3>
                    {ccnl.desc && <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed">{ccnl.desc}</p>}
                  </div>
                  {/* Documenti + link esterno nella stessa griglia a 2 colonne */}
                  {(ccnl.docs.length > 0 || ccnl.extUrl) && (
                    <div className="grid sm:grid-cols-2 gap-4">
                      {ccnl.docs.map((doc) => (
                        <DocItem key={doc.label} doc={doc} />
                      ))}
                      {ccnl.extUrl && (
                        <a
                          href={ccnl.extUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group flex items-center gap-4 p-5 rounded-xl border border-[var(--confcom-border)] bg-white hover:border-[var(--confcom-blue)]/30 hover:shadow-md transition-all"
                        >
                          <p className="flex-1 text-sm font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] group-hover:text-[var(--confcom-blue)] transition-colors">Consulta il contratto su Confcommercio.it</p>
                          <ExternalLink size={18} className="text-[var(--confcom-text-muted)] shrink-0 group-hover:text-[var(--confcom-blue)] transition-colors" aria-hidden="true" />
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="/cta-background.jpg" alt="" className="w-full h-full object-cover" aria-hidden="true" />
          <div className="absolute inset-0" style={{ backgroundColor: "rgba(0, 59, 117, 0.88)" }} />
        </div>
        <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Per maggiori informazioni</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight mt-3 mb-8">Contattaci</h2>

          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 text-left" data-testid="contrattazione-collettiva-contatti">
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2 text-white/80">
                <Mail size={14} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                <a href="mailto:sindacale@confcommercioroma.it" className="hover:text-white transition-colors">sindacale@confcommercioroma.it</a>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <Phone size={14} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                <a href="tel:+390668437221" className="hover:text-white transition-colors">Tel: 06 68437 221-290</a>
              </div>
            </div>
          </div>

          <Link
            to="/chi-siamo/struttura-tecnica#ufficio-lavoro-e-welfare"
            data-testid="contrattazione-collettiva-scopri-team"
            className="inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-6 py-3 rounded-md font-semibold hover:bg-white/90 transition-colors text-sm mt-8"
          >
            Scopri il Team <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>
      </section>

    </main>
  );
}
